module.exports = __webpack_public_path__ + "static/media/landscape.9a341a59.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/landscape.png
// module id = 9
// module chunks = 0